import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'components/commons/Icon';
import { FormattedMessage } from 'react-intl';
import { formatParsedDate } from 'utils';

import { WrapperUpdate } from './styles';

const Updated = ({ date }) => {
  return (
    <WrapperUpdate>
      <Icon name="watch" />
      <FormattedMessage id="updated" />
      {` `}
      {formatParsedDate(date, 'DD.MM.YYYY, HH:mm')}
    </WrapperUpdate>
  );
};

Updated.propTypes = {
  date: PropTypes.string.isRequired,
};

export default Updated;
